<template>
    <div class="project-detail-page">
        <!-- 顶部标题栏 -->
        <div class="page-header">
            <div class="header-left">
                <h2 class="project-name">{{ baseInfo.projectName || '—' }}</h2>
                <el-tag v-if="baseInfo.sourceTypeName" :type="statusType" size="small" class="status-tag">
                    {{ baseInfo.sourceTypeName }}
                </el-tag>
            </div>
            <!-- <el-button type="primary" size="medium" icon="el-icon-s-promotion" @click="handleEvaluate">
        发起智能评估
      </el-button> -->
        </div>

        <!-- 主体内容 -->
        <el-row :gutter="20" class="main-content" v-loading="loading">
            <!-- 左侧：项目概况 + 评估 -->
            <el-col :span="16">
                <!-- 项目概况卡片 -->
                <ProjectOverviewCard :baseInfo="baseInfo" />

                <!-- 项目评估卡片 -->
                <ProjectEvalCard />

                <!-- 跟进代表记录 卡片 -->
                <RecordCard :projectId="id" :contactList="contactList" />
            </el-col>

            <!-- 右侧：企业信息 + 联系人 -->
            <el-col :span="8">
                <!-- 企业介绍信息卡片 -->
                <CompanyInfoCard :enterpriseInfo="enterpriseInfo" />

                <!-- 系统联系人卡片（增删改成功后 @refresh 重新拉取联系人列表） -->
                <ContactListCard :projectId="id" :contactList="contactList" @refresh="getContactList" />
            </el-col>
        </el-row>
    </div>
</template>

<script>
import ProjectOverviewCard from './components/ProjectOverviewCard.vue'
import ProjectEvalCard from './components/ProjectEvalCard.vue'
import CompanyInfoCard from './components/CompanyInfoCard.vue'
import ContactListCard from './components/ContactListCard.vue'
import RecordCard from './components/RecordCard.vue'

export default {
name: 'ProjectDetail',
components: {
    ProjectOverviewCard,
    ProjectEvalCard,
    CompanyInfoCard,
    ContactListCard,
    RecordCard
},
data: function () {
    return {
        id: null,
        dataSource: null,
        sourceType: null,
        detail: null,

        loading: false,
        // project/Detail 一次请求，分发给各卡片组件
        baseInfo: {},
        enterpriseInfo: {},
        contactList: [],

        // 附件列表
        fileList: []
    }
},

computed: {
    statusType: function () {
        var map = {
            '立项备案': 'info',
            '专项审核': 'info',
            '用地审批': 'warning',
            '规划设计': 'warning',
            '招标公告': 'danger',
            '施工许可': 'success',
            '开工建设': 'success'
        }
        return map[this.baseInfo.sourceTypeName] || 'info'
    }
},
mounted: function () {
    this.id = this.$route.query.id || null;
    this.dataSource = this.$route.query.dataSource || null;
    this.sourceType = this.$route.query.sourceType || null;
    this.detail = this.$route.query.detail || null;
},
watch: {
    // 子组件 mounted 早于父组件 mounted（此时 id 还是 null），
    // 父组件拿到路由 id 后再统一拉取，分发数据
    id: function (val) {
        if (!val) return
        this.fetchDetail()
        this.getContactList()
    }
},

methods: {
    // 获取项目详情（接口写法同 index.vue），一次请求分发给各卡片
    fetchDetail: function () {
        if (!this.id) return
        var _this = this
        let ajaxUrl = this.$api.common.project.Detail()
        this.loading = true
        this.$axios.get(ajaxUrl, { params: { id: this.id } }).then(function (res) {
            _this.loading = false
            if (res.success) {
                var data = res.data || {}
                _this.baseInfo = data.baseInfo || {}
                _this.enterpriseInfo = data.enterpriseInfo || {}
            } else {
                _this.$message.error(res.msg)
            }
        }).catch(function (err) {
            _this.loading = false
            console.error('fetchDetail err:', err)
        })
    },

    // 获取联系人列表（单独走 projectContact/list，保证增删改后列表及时更新）
    getContactList: function () {
        if (!this.id) return
        var _this = this
        let ajaxUrl = this.$api.common.projectContact.list()
        this.$axios.get(ajaxUrl, { params: { projectId: this.id } }).then(function (res) {
            if (res.success) {
                // 返回字段与组件一一对应：id / contactName / genderName / departmentName /
                // position / mobile / phone / wechat / qq / email / remark / updateTime
                _this.contactList = res.list || []
            } else {
                _this.$message.error(res.msg)
            }
        }).catch(function (err) {
            console.error('getContactList err:', err)
        })
    },

    // 文件上传前校验（备用）
    beforeUpload: function (file) {
        var allowTypes = ['application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/pdf', 'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-powerpoint', 'application/vnd.openxmlformats-officedocument.presentationml.presentation']
        var isAllowType = allowTypes.indexOf(file.type) !== -1
        var isLt30M = file.size / 1024 / 1024 < 30

        if (!isAllowType) {
            this.$message.error('仅支持上传 Word、PDF、Excel、PPT 格式文件')
        }
        if (!isLt30M) {
            this.$message.error('单个文件大小不能超过 30MB')
        }
        return isAllowType && isLt30M
    },

    // 文件选择变化（备用）
    handleFileChange: function (file, fileList) {
        this.fileList = fileList
        console.log('文件列表:', fileList)
    }
}
}
</script>

<style lang="scss" scoped>
.project-detail-page {
    padding: 20px;
    background: #f5f7fa;
    min-height: calc(100vh - 84px);
}

/* 顶部标题栏 */
.page-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    padding: 0 4px;
}

.header-left {
    display: flex;
    align-items: center;
    gap: 12px;
}

.project-name {
    margin: 0;
    font-size: 20px;
    font-weight: 600;
    color: #303133;
}

.status-tag {
    font-weight: 600;
}

/* 主体内容 */
.main-content {
    .el-col {
        display: flex;
        flex-direction: column;
        gap: 16px;
    }
}
</style>